import React from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import { ResponsiveLine } from '@nivo/line';
import ChartPanelSkeleton from '../../layout/ChartPanelSkeleton';
import { formatMonth } from '../../../../utils';
import { theme, margin } from '../../constants';
import {
  SubscriptionsChartPointType,
  SubscriptionsStatType,
} from '../../../../../../../../types/subscriptionsSection';

interface Props {
  className?: string;
  chart: SubscriptionsChartPointType[];
  stats?: SubscriptionsStatType;
}

const SubscribersChartPanel: React.FC<Props> = ({
  className,
  chart,
  stats,
}) => {
  const { t } = useTranslation();
  const isSSR = typeof window === 'undefined';

  const newData = [
    {
      id: 'subscribers',
      data: chart.map(({ startDate, subscribers }) => ({
        x: formatMonth(startDate),
        y: subscribers,
      })),
    },
  ];

  return (
    <ChartPanelSkeleton
      className={className}
      totalTitle={t('widgets.subscriptionsSection.center.total.subscribers')}
      total={stats ? `${stats.activeSubscribers}` : ''}
      manageTitle={t('widgets.subscriptionsSection.center.button.subscribers')}
      manageHref={URLS.CUSTOMER_DASHBOARD}
    >
      {!isSSR && (
        <ResponsiveLine
          data={newData}
          margin={margin}
          axisLeft={{ tickValues: 4 }}
          enableGridX={false}
          gridYValues={4}
          xScale={{ type: 'point' }}
          yScale={{
            type: 'linear',
            min: 0,
          }}
          curve={`monotoneX`}
          colors={['#7579FF']}
          theme={theme}
          enableArea
        />
      )}
    </ChartPanelSkeleton>
  );
};
SubscribersChartPanel.displayName = 'SubscribersChartPanel';

export default SubscribersChartPanel;
